module.exports = __webpack_public_path__ + "static/0022-39d457940e1d780118c8ce14b3e40896.png";